// @flow

import React from 'react';

// In Codas both Private limited and LLPS are 'limited'
export const CompanyType = {
  LIMITED: 'limited',
  LLP: 'limited',
  NON_LIMITED: 'non_limited'
};

export const businessStructureToCompanyType = {
  'limited-company': CompanyType.LIMITED,
  'limited-liability-partnership': CompanyType.LLP,
  'partnership-less-4-partners': CompanyType.NON_LIMITED,
  'partnership-more-4-partners': CompanyType.NON_LIMITED,
  'non-limited': CompanyType.NON_LIMITED
};

export const loanTermRadios = [
  { value: 6, label: '6 months' },
  { value: 12, label: '12 months' },
  { value: 24, label: '2 years' },
  { value: 36, label: '3 years' },
  { value: 48, label: '4 years' },
  { value: 60, label: '5 years' },
  { value: 72, label: '6 years' }
];

export const businessStructureRadios = [
  { value: 'limited-company', label: 'Limited company' },
  {
    value: 'limited-liability-partnership',
    label: 'Limited liability partnership'
  },
  {
    value: 'partnership-less-4-partners',
    label: (
      <span>
        Partnership
        <br />
        (less than four partners)
      </span>
    )
  },
  {
    value: 'partnership-more-4-partners',
    label: (
      <span>
        Partnership
        <br />
        (four or more partners)
      </span>
    )
  },
  { value: 'non-limited', label: 'Sole trader' }
];

export const yesNoRadios = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

export const numberOfEmployeesRadios = [
  { value: 1, label: '1 - 5' },
  { value: 6, label: '6 - 10' },
  { value: 11, label: '11 - 20' },
  { value: 21, label: '21 - 50' },
  { value: 51, label: '51 - 249' },
  { value: 250, label: '250+' }
];

export const selfStatedIndustryOptions = [
  { value: 'Finance', label: 'Finance' },
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'Automotive', label: 'Automotive' },
  { value: 'Consumer Services', label: 'Consumer Services' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Education & Training', label: 'Education & Training' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Wholesale', label: 'Wholesale' },
  { value: 'Leisure & Hospitality', label: 'Leisure & Hospitality' },
  { value: 'Arts & Entertainment', label: 'Arts & Entertainment' },
  {
    value: 'I.T and Telecommunications',
    label: 'I.T and Telecommunications'
  },
  {
    value: 'Professional and Business Support',
    label: 'Professional and Business Support'
  },
  { value: 'Property and Construction', label: 'Property and Construction' },
  { value: 'Transport and Logistics', label: 'Transport and Logistics' },
  {
    value: 'Manufacturing and Engineering',
    label: 'Manufacturing and Engineering'
  }
];

const sageIntroducerId = '70cc5672-f4b7-44d4-bd3d-d72267aa5b28';
const worldpayIntroducerId = '779a7d2e-080d-4575-be3e-3f88041939e5';
const handepayIntroducerId = '751a8598-6956-47f7-9555-baff0f4516cb';
const paypointIntroducerId = 'e9bd2d7f-7692-41e1-9454-fdc37adbeae9';
export const limitedOnlyIntroducerIds = [
  sageIntroducerId,
  worldpayIntroducerId,
  handepayIntroducerId,
  paypointIntroducerId
];
